import { AnalysisStatus } from "@/api/analyses_status/types";
import * as analysisStatusApi from "@/api/analyses_status/index";

export async function getByUuid(uuid: string): Promise<AnalysisStatus[]> {
  return (await analysisStatusApi.getAnalysesStatus(uuid!)).data;
}

export async function getByFarmAnalysisUuid(analysisUuid: string, farmAnalysisUuid: string)
  : Promise<AnalysisStatus> {
  return (await analysisStatusApi.getFarmAnalysisStatusByUuid(analysisUuid!, farmAnalysisUuid!)).data;
}
